import WebSocketClient from './ws-client';
import MqttSocketClient from './mqtt-client';
import config from '../constants/config';

export const getSocketInstance = () => {
    if (!window.socketClient) {
        let socketClient = null;
        if (config.websocket.IS_ENABLE)
            socketClient = new WebSocketClient();
        else if (config.mqtt.IS_ENABLE)
            socketClient = new MqttSocketClient();
        window.socketClient = socketClient;
    }
    return window.socketClient ? window.socketClient : null;
}
